module.exports = __webpack_public_path__ + "static/media/search1.1168f1f0.svg";